import React from 'react';
import {classes} from './SecureCheckout.st.css';
import Lock from './Lock.svg';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {SPECS} from '../../constants';
import {useExperiments} from '@wix/yoshi-flow-editor';

export enum SecureCheckoutDataHook {
  lock = 'SecureCheckout.lock',
  text = 'SecureCheckout.text',
}
export const SecureCheckout = () => {
  const localeKeys = useLocaleKeys();
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);
  return (
    <div className={checkoutUIRevampOrderSummary ? classes.secureCheckout : classes.secureCheckoutOld}>
      <Lock
        className={classes.secureCheckoutLock}
        data-hook={SecureCheckoutDataHook.lock}
        aria-label={localeKeys.checkout.orderSummary.secureCheckout.label()}
      />
      <Text className={classes.secureCheckoutText} data-hook={SecureCheckoutDataHook.text}>
        {localeKeys.checkout.orderSummary.secureCheckout.label()}
      </Text>
    </div>
  );
};
